import React, { createContext } from 'react';

export interface ResourceSubmissionModalInfo {
  confirmClose: boolean;
  setConfirmClose: React.Dispatch<React.SetStateAction<boolean>>;
  preventClose: boolean;
  setPreventClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ResourceSubmissionModalContext = createContext<ResourceSubmissionModalInfo>({
  confirmClose: false,
  setConfirmClose: () => {},
  preventClose: false,
  setPreventClose: () => {},
});
